module.exports = __webpack_public_path__ + "static/NSmarkCert-0b1e82b2bb4340da26c648fa3814bf06.svg";